var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-handler"},_vm._l((_vm.toasts),function(toast,index){return _c('toast',{key:index,attrs:{"value":true,"type":toast.type,"canDismiss":toast.canDismiss},on:{"input":(value) => _vm.onToastInput(value, toast.id)}},[_vm._v(_vm._s(toast.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }